import cardService from '../services/cardService';

/**
 * Create card action (without dispatch)
 * @param {Object} cardPayload - Card payload containing card_token, card_brand, last4, exp_month, exp_year, is_default, first_name, last_name
 * @returns {Promise<Object>} Create card result
 */
export const saveCard = async (cardPayload) => {
  try {
    const response = await cardService.saveCard(cardPayload);
    
    if (response.success) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message };
    }
  } catch (error) {
    return { success: false, error: error.message || 'An unexpected error occurred' };
  }
};

/**
 * Fetch all cards for the authenticated user
 * @returns {Promise<{success: boolean, data?: Array, error?: string}>}
 */
export const fetchUserCards = async () => {
  try {
    const response = await cardService.fetchCards();

    if (response.success) {
      const responseData = response.data;
      const cards = Array.isArray(responseData)
        ? responseData
        : Array.isArray(responseData?.cards)
          ? responseData.cards
          : [];

      return { success: true, data: cards };
    }

    return { success: false, error: response.message || 'Failed to fetch cards' };
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch cards' };
  }
};

/**
 * Set a card as the default payment method
 * @param {string} cardId - Card identifier
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export const setDefaultCard = async (cardId) => {
  try {
    const response = await cardService.setDefaultCard(cardId);

    if (response.success) {
      return { success: true };
    }

    return { success: false, error: response.message || 'Failed to set default card' };
  } catch (error) {
    return { success: false, error: error.message || 'Failed to set default card' };
  }
};

/**
 * Delete a card for the authenticated user
 * @param {string} cardId - Card identifier
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export const deleteUserCard = async (cardId) => {
  try {
    const response = await cardService.deleteCard(cardId);

    if (response.success) {
      return { success: true };
    }

    return { success: false, error: response.message || 'Failed to delete card' };
  } catch (error) {
    return { success: false, error: error.message || 'Failed to delete card' };
  }
};

/**
 * Check if a specific card has an active subscription
 * @param {string} cardId - Card identifier
 * @returns {Promise<{success: boolean, data?: boolean, error?: string}>}
 */
export const checkCardActiveSubscription = async (cardId) => {
  try {
    const response = await cardService.checkActiveSubscription(cardId);

    if (response.success) {
      const status =
        typeof response.data?.isActiveSubscription === 'boolean'
          ? response.data.isActiveSubscription
          : Boolean(response.data?.is_active_subscription);

      return { success: true, data: status };
    }

    return { success: false, error: response.message || 'Failed to check active subscription' };
  } catch (error) {
    return {
      success: false,
      error: error.message || 'Failed to check active subscription',
    };
  }
};

